import React, { Component } from "react";
import AsyncComponent from "../../../components/async-component";
import PageWrap from "../../../components/page-wrap";
import PageContent from "../../../components/page-content";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import { CalendarContextProvider } from "./context/calendar-context";

class CalendarPage extends Component {
    componentDidMount = updateBreadcrumb;
    render() {
        return (
            <PageWrap>
                <PageContent>
                    <CalendarContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </CalendarContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default CalendarPage;
